import {NgModule} from '@angular/core';
import {LoaderComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgIf, NgStyle} from '@angular/common';

@NgModule({
  imports: [
    IonicModule,
    NgStyle,
    NgClass,
    NgIf
  ],
  exports: [
    LoaderComponent
  ],
  declarations: [LoaderComponent],
  providers: [],
})
export class LoaderComponentModule {
}
